import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-google-map',
  templateUrl: './google-map.component.html',
  styleUrls: ['./google-map.component.css']
})
export class GoogleMapComponent {
  @Input() latitude: number;
  @Input() longitude: number;

  ngOnInit(): void {
    console.log("lat..",this.latitude)
    console.log("log..",this.longitude)

  }
}
